/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Checkbox,
  Loader,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import Update from 'immutability-helper';
import api from '../../api';

class MyNotifications extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.disposers = [];
    this.state = {
      isLoading: false,
      isOpenAlert: false,
      isOpenModal: false,
      notificationOptions: [],
      defaultSettings: [],
    };
    this.handleRevert = this.handleRevert.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.setMyNotifications = this.setMyNotifications.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { state } = this.props;
    this.getMyNotifications();

    this.disposers.push(
      reaction(
        () => {
          return state.user.localeParams;
        },
        () => {
          this.getMyNotifications();
        }
      )
    );
  }

  componentWillUnmount() {
    this.disposers.forEach((disposer) => {
      disposer();
    });
  }

  handleCheckChange = (e, selectedEntity, optionIndex, itemsIndex) => {
    const { notificationOptions } = this.state;
    const cloneArray = [...notificationOptions];

    const itemsArray = cloneArray[optionIndex].items;
    const updatedArray = Update(itemsArray[itemsIndex], { selected: { $set: !selectedEntity.selected } });
    const newData = Update(itemsArray, {
      $splice: [[itemsIndex, 1, updatedArray]],
    });

    cloneArray[optionIndex] = { ...cloneArray[optionIndex], items: newData };

    this.setState({
      notificationOptions: cloneArray,
    });
  };

  handleRevert = () => {
    const { defaultSettings } = this.state;

    this.setState({
      notificationOptions: defaultSettings,
    });
  };

  handleSave = () => {
    const { t } = this.props;

    this.modalAction = t('modal.title.attention');
    this.modalBody = t('my_page.save_scan_option');
    this.setState({
      isOpenModal: true,
    });
  };

  getMyNotifications() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getUserNotifications()
        .then((response) => {
          const data = response.response;
          this.setState({
            notificationOptions: data,
            defaultSettings: data,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');
          if (o.error_description) {
            this.modalBody = o.error_description;
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          }
        });
    });
  }

  setMyNotifications() {
    const { notificationOptions } = this.state;
    const { t } = this.props;
    const newOptions = {};

    notificationOptions.map((entity) => {
      let i = 0;
      const items = [];
      for (i; i < entity.items.length; i++) {
        if (entity.items[i].selected) {
          items.push(entity.items[i].item);
        }
      }
      newOptions[entity.option] = items;
      return null;
    });

    this.setState({
      isOpenModal: false,
      isLoading: true,
    }, () => {
      api
        .setUserNotifications(newOptions)
        .then((response) => {
          const data = response.response;

          this.setState({
            notificationOptions: data,
            defaultSettings: data,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = t('modal.title.attention');

          if (o.error_description) {
            this.modalBody = o.error_description;
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          } else if (o.error === '422-211') {
            this.modalBody = t('modal.error.error_422_211_export');
            this.setState({
              isLoading: false,
              isOpenAlert: true,
            });
          }
        });
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlert: false,
    });
  }

  render() {
    const {
      isLoading,
      notificationOptions,
    } = this.state;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return isLoading ? (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      ) : element;
    };

    const renderItems = (array, optionIndex) => {
      return array.map((entity, itemsIndex) => {
        return (
          <li key={entity.item}>
            <Checkbox
              label={entity.display_item}
              value={entity.item}
              checked={entity.selected}
              onChange={
                (e) => {
                  return this.handleCheckChange(e, entity, optionIndex, itemsIndex);
                }
              }
            />
          </li>
        );
      });
    };

    return (
      <div style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">
              {t('my_page.notifications')}
            </h3>
          </div>
        </div>
        {renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              {
                notificationOptions.length !== 0
                      && notificationOptions.map((list, index) => {
                        return (
                          <div className="setting_issues_content_item" key={list.option}>
                            <span className="label">{list.display_option}</span>
                            <ul className="options">
                              {renderItems(list.items, index)}
                            </ul>
                          </div>
                        );
                      })
              }
            </div>
            <div className="setting_issues_bottom" style={{ padding: '0 30px', bottom: '-480px', position: 'absolute' }}>
              <a className="revert" onClick={this.handleRevert} onKeyUp={this.handleRevert}>{t('settings.button.revert')}</a>
              <a className="save" onClick={this.handleSave} onKeyUp={this.handleSave}>{t('modal.button.save')}</a>
            </div>
          </div>
        )}
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.setMyNotifications} onKeyUp={this.setMyNotifications}>
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withTranslation()(inject('state')(observer(MyNotifications)));
